module.exports = __webpack_public_path__ + "static/media/code.a85b8cca.svg";